import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { IntennseOfficialViewComponent } from './intennse-official-view.component';
import { TempIntennseViewRoutingModule } from './intennse-official-view-routing.module';
import { IntBodyComponent } from './int-body/int-body.component';
import { IntPointComponent } from './int-body/int-point/int-point.component';
import { StartMatchModule } from '../match-tracker/start-match/start-match.module';
import { StopwatchModule } from '../_shared/components/stopwatch/stopwatch.module';
import { IntSelectServerComponent } from './int-select-server/int-select-server.component';
import { TrackerBoardModule } from '../match-tracker/tracker-board/tracker-board.module';
import { SharedModule } from '../_shared/shared.module';
import { TrackerBarModule } from '../scoreboard/tracker-bar/tracker-bar.module';
import { NetworkStatusComponent } from '../_shared/components/network-status/network-status.component';
import { ScoreListPageModule } from '../score-list/score-list.module';
import { TimeoutModule } from '../_shared/components/timeout/timeout.module';
import { IntPointContainerComponent } from './int-point-container/int-point-container.component';
import { IntTeamNameComponent } from './int-team-name/int-team-name.component';
import { SubstitutionComponent } from '../substitution/substitution.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TempIntennseViewRoutingModule,
    IntBodyComponent,
    IntPointComponent,
    StartMatchModule,
    StopwatchModule,
    TrackerBoardModule,
    TrackerBarModule,
    SharedModule,
    NetworkStatusComponent,
    ScoreListPageModule,
    TimeoutModule, 
    IntPointContainerComponent,
    IntTeamNameComponent,
    SubstitutionComponent,
    TranslateModule
  ],
  declarations: [
    IntennseOfficialViewComponent, 
    IntSelectServerComponent, 
    ],
  providers: [],
  exports: [
    IntSelectServerComponent, 
    IntTeamNameComponent
    ],
})
export class TempIntennseViewModule {}
